import { Fragment } from "react";
import {Grid, Icon, Typography} from "@material-ui/core";
import {CameraAltTwoTone} from "@material-ui/icons";
import {getItemsByCategory, menuCategories} from "../../common/menuConstants";
import { getBeveragesByCategory, beveragesCategories } from '../../common/beveragesConstants';
import {makeStyles} from "@material-ui/core/styles";
import '../menu-styles.scss';

const useStyles = makeStyles({
  root: {
    color: 'white',
    backgroundColor: 'black',
    border: '1px solid red',
  },
  camera: {
    // float: 'right',
    paddingRight: '10px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  title: {
    paddingTop: '15px',
    paddingBottom: '8px',
    fontSize: '40px',
  }
});

const MenuCategory = ({ categoryId, handleCameraClick, size, beverageView = false }) => {
  const classes = useStyles();
  const items = beverageView ? getBeveragesByCategory(categoryId) : getItemsByCategory(categoryId);
  const category = (beverageView ?
      beveragesCategories.find((category) => category.id === categoryId)
      :
      menuCategories.find((category) => category.id === categoryId)
  );
  return (
    <>
      <Grid item xs={12} style={{ marginTop: '35px', marginBottom: '10px' }}>
        <div className="title-container">
        <div className="title-border">
          <div style={{ paddingLeft: '25%', paddingRight: '25%' }}>
            <Typography variant="h3" className={classes.title}>{category.title}</Typography>
          </div>
        </div>
        </div>
      </Grid>

      {
        categoryId === 5 && !beverageView ?
        <div style={{ padding: '10px' }}>
          <Typography style={{ fontSize: '20px' }}>
            Announced daily via restaurant easel and on our <a
            href="https://facebook.com/CastanedaTacosAndRestaurant"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: 'none' }}
          > Facebook page</a>.
            </Typography>
        </div>
          :
        <Grid container style={{ padding: '20px' }}>
          {items.map((i) => (
            <Grid item xs={size === 'sm' ? 6: 12} md={size === 'sm' ? 4: 6} key={i.id}>
              <div style={{ padding: `${size === 'sm' ? '5px' : '10px 50px'}` }}>
                <Typography variant={size === 'sm' ? "h6" : "h5"}>
                  {i.img ?
                    <Fragment>
                      <Icon
                        // className={classes.camera}
                        onClick={() => handleCameraClick(i)}
                      >
                        <CameraAltTwoTone
                          className={classes.camera}
                          color='primary'
                        />
                      </Icon>
                      {i.name}
                    </Fragment>
                    : <div style={{ paddingLeft: '35px' }}>
                      {i.name}
                    </div>
                  }
                </Typography>

                <Typography variant="body2" style={{ paddingTop: '8px', paddingLeft: '40px' }}>
                  {i.description}
                </Typography>

              </div>
            </Grid>
          ))}
        </Grid>

      }

    </>
  );
};

export default MenuCategory;
